import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import CriteriaListBase from '../components/CriteriaListBase';
import CriteriaElement from './CriteriaElement';
import {VARIANT_CODE} from '../constants/criteriaElement.variants';
import arrayExtension from 'libs/arrayExtension'

const style = theme => ({
    root: {}
})

function CriteriaList({
                          classes,
                          formikProps,
                          disabled
                      }) {
    const id = 'intervalList';

    const handleAdd = () => {
        let lastItem = arrayExtension.lastItem(formikProps.values[id]);
        if (lastItem === undefined) {
            lastItem = {
                to: '',
                id: 0,
                fromInclusive: false,
                toInclusive: false
            }
        }

        formikProps.setFieldValue(id,
            [...formikProps.values[id], {
                type: VARIANT_CODE.RANGE,
                from: lastItem.to,
                to: '',
                fromInclusive: !lastItem.toInclusive,
                toInclusive: false,
                value: '',
                id: lastItem.id + 1,
            }])
    }

    return (
        <div className={classes.root}>
            <CriteriaListBase
                id={id}
                formikProps={formikProps}
                Element={CriteriaElement}
                onAdd={handleAdd}
                disabled={disabled}
            />
        </div>
    )
}

CriteriaList.propTypes = {
    classes: PropTypes.any,
}

CriteriaList.defaultProps = {}

export default withStyles(style)(CriteriaList);